import { fetchUrlPreviewBatched } from 'utils/urlPreviewBatcher';

class UrlPreview {
  async generate(url) {
    try {
      return await fetchUrlPreviewBatched(url);
    } catch {
      return null;
    }
  }
}

export default new UrlPreview();
